<template>
  <div>
    <div class="content-body">
      <div class="right-box background">
        <div class="right-title">
          <div class="title" v-text="$t('index.title')"></div>
          <div class="right-condition">
            <el-select v-model="adv_id" size="small" style="width: 120px; margin-right: 20px;" @change="setChart">
              <el-option :label="$t('index.select_font')" value=""></el-option>
              <el-option v-for="item in options" :key="item.adv_id" :label="item.title" :value="item.adv_id"></el-option>
            </el-select>
            <el-date-picker v-model="time" type="daterange" align="right" :value-format="'yyyy-MM-dd'" unlink-panels range-separator="~" start-placeholder="" end-placeholder="" @change="setChart" size="small"></el-date-picker>
          </div>
        </div>
        <div class="item-content">
          <div :class="'one-item' + (type === '6' ? ' current-item' : '')" @click="type = '6'">
            <div class="icon"><i class="fa fa-jpy" aria-hidden="true"></i></div>
            <div class="bottom" v-text="$t('index.btn_1')"></div>
            <div class="top" v-text="num['pay_money']"></div>
          </div>
          <div :class="'one-item' + (type === '1' ? ' current-item' : '')" @click="type = '1'">
            <div class="icon"><i class="fa fa-list" aria-hidden="true"></i></div>
            <div class="bottom" v-text="$t('index.btn_2')"></div>
            <div class="top" v-text="num['read_num']"></div>
          </div>
          <div :class="'one-item' + (type === '2' ? ' current-item' : '')" @click="type = '2'" style="margin-right: 0px;">
            <div class="icon"><i class="fa fa-mouse-pointer" aria-hidden="true"></i></div>
            <div class="bottom" v-text="$t('index.btn_3')"></div>
            <div class="top" v-text="num['look_num']"></div>
          </div>
        </div>
        <div class="echart" style="height: 420px;">
          <div id="echarts-records" :style="{width: 'calc(100% - 48px)', height: '400px', padding: '16px 24px', background: '#fff'}"></div>
        </div>
      </div>

      <div class="left-box">
        <div class="account-box background">
          <div class="header-name">{{ $t('index.hello') }}，{{ user_info['company_name'] }}</div>
          <div class="handle">
            <span class="handle-state" v-text="$t('index.pass')"></span>
          </div>
          <div class="account-price">
            <div class="price-font" v-text="$t('index.balance')"></div>
            <div class="price" v-text="data.company_balance"></div>
          </div>
          <div class="account-price" style="border-bottom: none;">
            <div class="price-font" v-text="$t('index.good')"></div>
            <div class="price">100</div>
          </div>
        </div>
        <div class="expeded-box background">
          <el-carousel height="150px">
            <el-carousel-item v-for="item in banner" :key="item">
              <a :href="item.url" target="_blank"><img :src="domain + item.pic" alt=""></a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <el-dialog :title="$t('index.layer_title')" :close-on-click-modal="false" :visible.sync="dialogVisible" width="30%">
        <el-form ref="form" label-width="80px" label-position="left">
          <el-form-item :label="$t('index.layer_form_title1')">
            <el-radio-group v-model="checked" size="small">
              <el-radio-button :label="1">{{ $t('index.layer_form_btn1') }}</el-radio-button>
              <el-radio-button :label="0">{{ $t('index.layer_form_btn2') }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('index.layer_form_title2')" v-show="checked !== 1">
            <el-input v-model="input" :placeholder="$t('index.layer_form_desc2')"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button @click="dialogVisible = false" size="mini" v-text="$t('common.layer_btn_cancel')"></el-button>
          <el-button type="primary" @click="sure" size="mini" v-text="$t('common.layer_btn_sure')"></el-button>
        </span>
      </el-dialog>
    </div>
    <div class="footer-content">
      <div class="footer-item">
        <div class="product-card-title" v-text="$t('index.product_title1')"></div>
        <div>
          <div class="product-card-details">
            <span class="product-card-name" v-text="$t('index.btn_1')"></span>
            <span class="product-card-value" v-text="data.pay_price"></span>
          </div>
          <div class="product-card-details">
            <span class="product-card-name" v-text="$t('index.product_title1_1')"></span>
            <span class="product-card-value product-card-value-nolimit">{{ showBudgetTitle(data.company_budget) }}</span>
            <div class="product-edit-budget" @click="showBudget">
              <svg class="one-ui-icon-svg icon-edit" viewBox="0 0 34 34">
                <g fill="#000" fill-rule="evenodd">
                  <path d="M30.5 14v12a4.5 4.5 0 0 1-4.5 4.5H8A4.5 4.5 0 0 1 3.5 26V8A4.5 4.5 0 0 1 8 3.5h12a1.5 1.5 0 0 0 0-3H8A7.5 7.5 0 0 0 .5 8v18A7.5 7.5 0 0 0 8 33.5h18a7.5 7.5 0 0 0 7.5-7.5V14a1.5 1.5 0 0 0-3 0z" fill-rule="nonzero"></path>
                  <path d="M12.174 18.955L30.205.924a1.5 1.5 0 0 1 2.121 2.121L14.295 21.076a1.5 1.5 0 0 1-2.121-2.121z"></path>
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div class="product-card-btn"><el-button type="primary" size="mini" @click="jumpPage" v-text="$t('index.product_btn1')"></el-button></div>
      </div>
      <div class="footer-item">
        <div class="product-card-title" v-text="$t('index.product_title2')"></div>
        <div class="product-card-desc" v-text="$t('index.product_content2')"></div>
        <div class="product-card-btn"><el-button disabled size="mini" v-text="$t('index.product_btn2')"></el-button></div>
      </div>
      <div class="footer-item">
        <div class="product-card-title" v-text="$t('index.product_title3')"></div>
        <div class="product-card-desc" v-text="$t('index.product_content3')"></div>
        <div class="product-card-btn"><el-button disabled size="mini" v-text="$t('index.product_btn2')"></el-button></div>
      </div>
    </div>
    <div style="height: 100px;"></div>
  </div>
</template>

<script>
import echarts from 'echarts';
// @ is an alias to /src
export default {
  name: 'index',
  data() {
    return {
      type: '6',
      options: [],
      adv_id: '',
      num: {
        read_num: 0,
        look_num: 0,
        pay_money: 0
      },
      time: [],
      curentComponents: 'PlanView',
      data: [],
      dialogVisible: false,
      input: '',
      checked: 0,
      user_info: [],
      dateType: '1',
      count: [],
      tableData: [],
      banner: [],
      domain: ''
    };
  },
  mounted() {
    this.setTimeInit();
    this.user_info = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info')) : [];
    this.$http.post('/trader/index/getIndexInfo').then(res => {
      if (res.code === 200) {
        this.data = res.data;
        this.checked = parseFloat(res.data.company_budget) >= 99999999 ? 1 : 0;
        this.input = parseFloat(res.data.company_budget);
        this.tableData = res.data.adv_lists;
        this.banner = res.data.banner;
        this.domain = res.data.domain;
        // this.$function.hiddenLoading();
        this.setChart();
        this.getAdvLists();
      }
    });
  },
  methods: {
    getAdvLists() {
      this.$http.post('/trader/index/getAdvPlusData').then(res => {
        if (res.code === 200) {
          this.options = res.data;
        }
      });
    },
    setTimeInit() {
      const day1 = new Date();
      day1.setTime(day1.getTime() - (24 * 60 * 60 * 1000 * 7));
      const preToday = day1.getFullYear() + '-' + ((day1.getMonth() + 1) < 10 ? '0' + (day1.getMonth() + 1) : (day1.getMonth() + 1)) + '-' + (day1.getDate() < 10 ? '0' + day1.getDate() : day1.getDate());
      const day2 = new Date();
      day2.setTime(day2.getTime());
      const today = day2.getFullYear() + '-' + ((day2.getMonth() + 1) < 10 ? '0' + (day2.getMonth() + 1) : (day2.getMonth() + 1)) + '-' + (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate());
      this.time = [preToday, today];
    },
    setChart() {
      this.$http.post('/trader/data/getTableLists', { value: this.type, pay_time: this.time, adv_id: this.adv_id }).then(res => {
        if (res.code === 200) {
          this.num = res.num;
          const option = {
            xAxis: {
              type: 'category',
              boundaryGap: false
            },
            yAxis: {
              type: 'value',
              boundaryGap: [0, '30%']
            },
            grid: [
              {
                show: true,
                borderWidth: 0,
                backgroundColor: '#fff',
                shadowColor: 'rgba(0, 0, 0, 0.3)',
                shadowBlur: 2
              }
            ],
            visualMap: {
              type: 'piecewise',
              show: false,
              dimension: 0,
              seriesIndex: 0,
              pieces: [{
                gt: 1,
                lt: 3,
                color: 'rgba(0, 180, 0, 0.5)'
              }, {
                gt: 5,
                lt: 7,
                color: 'rgba(0, 180, 0, 0.5)'
              }]
            },
            series: [
              {
                type: 'line',
                smooth: 0.6,
                symbol: 'none',
                lineStyle: {
                  color: res.color,
                  width: 2
                },
                markLine: {
                  symbol: ['none', 'none'],
                  label: { show: false },
                  data: [
                    { xAxis: 1 },
                    { xAxis: 3 },
                    { xAxis: 5 },
                    { xAxis: 7 }
                  ]
                },
                areaStyle: {},
                data: res.static.default
              }
            ]
          };
          const echartsRecords = echarts.init(document.getElementById('echarts-records'), 'walden');
          echartsRecords.setOption(option);
          this.$function.hiddenLoading();
        }
      });
    },
    sure() {
      this.$http.post('/trader/index/updateBudget', {
        budget: this.input
      }).then(res => {
        if (res.code === 200) {
          this.data.company_budget = this.input;
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.msg);
        }
        this.dialogVisible = false;
      });
    },
    showBudget() {
      this.checked = parseInt(this.input) === 99999999 ? 1 : 0;
      this.dialogVisible = true;
    },
    showBudgetTitle(val) {
      return parseInt(val) >= 99999999 ? this.$t('index.budget_title') : val;
    },
    jumpPage() {
      this.$emit('jumpAdv', 'planView');
    },
    jumpPlan() {
      this.$emit('jump_plan');
    },
    getForm(time) {
      return this.$function.formatDate(time, 'MM-dd');
    }
  },
  watch: {
    checked(newVal) {
      this.input = parseInt(newVal) ? 99999999 : 0;
    },
    type() {
      this.setChart();
    }
  }
};
</script>
<style lang="less" scoped="">
  .content-body {
    display: flex;
  }
  .background {
    background: #fff;
    border: 1px solid #f6f5f5;
    box-shadow: 0 6px 19px 0 rgba(0, 0, 0, .05);
    border-radius: 4px;
  }
  .left-box {
    width: 278px;
    .account-box {
      width: 236px;
      padding: 20px;
      border-radius: 8px;
      .header-name {
        font-size: 14px;
        color: #333;
      }
      .handle {
        display: flex;
        margin-top: 10px;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
        .handle-state {
          font-size: 12px;
          border: 1px solid #d4d4d4;
          border-radius: 9px;
          padding: 0 6px;
          color: #333;
          height: 20px;
          line-height: 20px;
        }
      }
      .account-price {
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
        margin-top: 20px;
        .price-font {
          font-size: 12px;
          color: #999;
          line-height: 18px;
          margin-bottom: 2px;
        }
        .price {
          font-size: 22px;
          color: #000;
          line-height: 26px;
        }
      }
    }
    .expeded-box {
      width: 276px;
      margin-top: 20px;
      border-radius: 8px;
      overflow: hidden;
      img {
        width: 100%;
        height: 150px;
      }
    }
  }

  .right-box {
    width: calc(100% - 341px);
    padding: 10px 20px;
    margin-right: 23px;
    .right-title {
      font-size: 16px;
      color: #333;
      letter-spacing: 0;
      display: flex;
      justify-content: space-between;
      span {
        margin-left: 20px;
        font-size: 12px;
        font-weight: normal;
      }
      .right-border {
        border: 1px solid #E8ECEE;
        border-radius: 5px;
        padding: 5px 8px;
        font-weight: normal;
        font-size: 12px;
      }
    }
    .item-content {
      display: flex;
      justify-content: space-between;
      margin: 30px 0;
      .one-item {
        width: calc(100% - 10px);
        margin-right: 8px;
        padding: 17px 12px;
        border-radius: 4px;
        background: rgba(0,0,0,.02);
        position: relative;
        cursor: pointer;
        .top {
          margin-left: 80px;
          font-size: 24px;
          color: #333;
          padding-top: 8px;
        }
        .bottom {
          margin-left: 80px;
          font-size: 12px;
          padding-top: 8px;
          color: #666;
          font-weight: normal;
        }
        .icon {
          position: absolute;
          left: 20px;
          top: 30px;
          color: #3E88F5;
          i {
            font-size: 36px;
          }
        }
      }
      .current-item {
        background: #386BFF;
        .top {
          color: #fff;
        }
        .bottom {
          color: #fff;
        }
        .icon {
          color: #B9BBFF;
        }
      }
    }
  }

  .footer-content {
    width: calc(100% - 365px);
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    .footer-item {
      width: 32%;
      height: 164px;
      background-color: #fff;
      display: inline-table;
      padding: 20px;
      box-shadow: 1px 1px 10px 0 rgba(183,183,188,.1);
      border-radius: 8px;
      position: relative;
      box-sizing: border-box;
      .product-card-title {
        font-size: 14px;
        line-height: 25px;
        margin-bottom: 20px;
      }
      .product-card-details {
        margin-top: 20px;
        display: table;
        font-size: 12px;
        .product-card-name {
          color: #999;
          padding-right: 10px;
        }
        .product-card-value {
          font-size: 16px;
        }
        .product-card-value-nolimit {
          font-size: 14px;
        }
        .product-edit-budget {
          display: inline;
          cursor: pointer;
          padding-left: 6px;
          .one-ui-icon-svg {
            fill: currentColor;
            display: inline-block;
            width: 1em;
            height: 1em;
          }
        }
      }
      .product-card-desc {
        font-size: 12px;
        line-height: 20px;
        color: #666;
      }
      .product-card-btn {
        position: absolute;
        right: 10px;
        top: 15px;
      }
    }
  }

</style>
